import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatCount } from "@/utils/comics";

interface ComicCardProps {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-secondary-100">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - JMComic漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2">
          <span
            className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${
              comic.status === "连载"
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-900 text-background-50"
            }`}
          >
            {comic.status}
          </span>
          <span className="rounded bg-background-50/90 px-1.5 py-0.5 text-[10px] font-medium text-foreground-700">
            {comic.categoryName}
          </span>
        </div>
        {typeof rank === "number" && (
          <span className="absolute bottom-2 left-2 flex h-6 min-w-6 items-center justify-center rounded bg-accent-500 px-1.5 font-heading text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {comic.author} · {comic.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-2.5 flex items-center gap-1.5 border-t border-background-200 pt-2.5">
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500"></span>
          <span className="truncate text-[11px] text-foreground-600">{comic.latestChapter}</span>
        </div>
        <div className="mt-1 flex items-center justify-between text-[10px] text-foreground-400">
          <span>{comic.updatedAt.slice(5, 10)} 更新</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatCount(comic.viewCount)}
          </span>
        </div>
      </div>
    </Link>
  );
}